import React, { Component } from "react";
import {
  Button,
  Space,
  Col,
  message,
  Form,
  Input,
  Row,
  Select,
  Upload,
  Modal,
  Tooltip,
  Spin,
  Checkbox,
  DatePicker,
  Radio
} from "antd";
import "./Form.css";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import config from "../config";

import CreditStore from "../store/CreditStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";

import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import conf from "../config";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import dayjs from "dayjs";
import { baseURL } from "../components/Utility";
import CompanyStore from "../store/CompanyStore";

const layout = {
  labelCol: { span: 23 },
  wrapperCol: { span: 30 },
};
const { Option } = Select;
class CreditRequestAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      searchField: "",
      creditType: "",
      getRolesList: [],
      departmentId: "",
      userId: -1,
      fileList: [],
      showDeptForm: false,
      loading: false,
      isadmin: 0,
      userType: 1,
      loadingSpin: false,
      disabledField: false,

      submitAction: null,
      serviceDate:dayjs().startOf("day"),
      expiryDate:"",
      bankSelected: "",
      trackerId:""
    };
    
 
    this.creditStore = new CreditStore();
    this.vehicleStore = new VehicleStore();
    this.companyStore = new CompanyStore();
    
    // this.selectDepartment = this.selectDepartment.bind(this);
    this.cookies = new Cookies();
    this.handleChange = this.handleChange.bind(this);
    this.selectCreditType = this.selectCreditType.bind(this);
   
 
  }
  async handleChange(comp) {
     await this.setState({ companyId: comp.value });
     this.context.viewStateStore.setCreditStates({
        companyId: comp.value,
         creditType: this.state.creditType,
      });

      //console.log(this.context.viewStateStore.creditStatesObj);
   
  }

  async handleSearch() {
    await this.vehicleStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,
    });
    await this.setState({ loadList: 1 });
  }

   async selectCreditType(value, option) {
      await this.setState({creditType:value})
      //if(value === 'New'){
        const trackerId = await this.vehicleStore.getTrackerId();
        this.formRef.current.setFieldsValue({
        trackerId: trackerId,
      });
       // console.log(trackerId);
       // await this.setState({trackerId: trackerId});

      //}// if( value !== 'internet banking'){
      //   this.setState({bankSelected: ''});
      // }
       
     // console.log(this.context.viewStateStore.creditStates.creditType);
    }

   

  onCreditSubmit = async (fieldsValue) => {
    
  // console.log(this.state.serviceDate.format("YYYY-MM-DD"))

    const data = {
      ...fieldsValue,
     
      expiryDate: fieldsValue?.expiryDate?fieldsValue?.expiryDate?.format("YYYY-MM-DD") : null,
      serviceDate: this.state.serviceDate.format("YYYY-MM-DD"),
      companyId: this.state.companyId,
      vehicleId: this.props.certificateVehicleId, 
      
    };
    console.log(data);
    const response = await this.vehicleStore.addVehicleCertificate(data);

   
    const resp = response.data;
//console.log(response)
     if(response.data.success=='S'){
       // response.chassisNo = data.chassisNo;
       // response.serviceDate = this.state.serviceDate.format("YYYY-MM-DD"),
        //response.expiryDate = fieldsValue?.expiryDate?fieldsValue?.expiryDate?.format("YYYY-MM-DD") : null,
        response.companyId = data.companyId;
        this.donwloadPDF(resp);
    }   
     await this.props.response(response);
   // this.handleSearch()
    this.setState({ loading: false });
  };

  donwloadPDF = (response)=>{
    console.log(response)
    window.location.href =
         baseURL +
         "index.php?c=vehicle&a=vehicleCertificatePdf&cid=" +response.data.companyId +
         "&vid=" + response.data.vehicleId +
         "&IMEI=" + response.data.full_imei +
          "&vno=" + response.data.vehicleNo +
          "&chassisNo=" + response.data.chassisNo +
          "&serviceDate=" + response.data.serviceDate +
          "&expiryDate=" + response.data.expiryDate;

  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      this.context.viewStateStore.setVehicleStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });
    }

    const vehicleId = this.props.certificateVehicleId;
console.log(vehicleId);
    if (vehicleId) {
      await this.filldata(vehicleId);
      this.setState({ vehicleId: vehicleId });
    }
   
  }
   
   
filldata = async (vehicleId) => {
    await this.setState({ loadingSpin: true });
    const getVehicleDetails = await this.vehicleStore.getVehicleData(vehicleId);
    console.log(getVehicleDetails)
    await this.setState({
      companyId: getVehicleDetails.companyId,
      vehicleId: getVehicleDetails.vehicleId,
    });
    const singleData = await this.companyStore.getCompanyDataById(
      getVehicleDetails.companyId
    );
  
   // console.log(singleData)
 // console.log(singleData[0].label)
     this.formRef.current.setFieldsValue({
        companyId: singleData[0].label,
        vehicleModel: getVehicleDetails.model,
        plateno: getVehicleDetails.vehicleNo,
        chassisNo: getVehicleDetails.chassisNo,
        expiryDate: dayjs().add(1, "year"),//getVehicleDetails?.expiryDate ? dayjs(getVehicleDetails?.expiryDate): null,
      });
     await this.setState({ loadingSpin: false });  
}
  
  handleButtonClick = (action) => {
    this.setState({ submitAction: action });
  };
  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          {/* change style */}
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              {...layout}
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onCreditSubmit}
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                {/* css class */}
                <Col span={12} className="formColumnClass">
                  {/* css class */}

                  
                  

                  <Form.Item
                      name="companyId"
                      label={this.context.translate("_ACCOUNT_")}
                      rules={[{ required: true,message: this.context.translate("_PLEASE_SELECT_ACCOUNT_") }]}
                      // style={this.context.isAdmin===1? {display:'none'}:''}
                    >
                     <Input />
                    </Form.Item>

                   <Form.Item
                      name="serviceType"
                      label={this.context.translate(
                        "_SERVICE_TYPE_"
                      )}
                      rules={[{ required: true,message: this.context.translate("_SELECT_SERVICE_TYPE_") }]}
                    >
                      <Select
                        placeholder={this.context.translate(
                                  "_SELECT_SERVICETYPE_"
                                )}
                        onChange={async (val, option) => {
                            await this.selectCreditType(val, option);
                        }}        
                      >
                       
                        <Select.Option value="New">
                          {this.context.translate("_NEW_")}
                        </Select.Option>
                        <Select.Option value="Renew">
                          {this.context.translate("_RENEW_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                
                    <Form.Item
                    name="trackerId"
                    label={this.context.translate("_TRACKER_ID_")}
                    rules={[{ required: true }]}
                  >
                    <Input value={this.state.trackerId}  />
                  </Form.Item>
                  <Form.Item
                    name="plateno"
                    label={this.context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_PLATENO_")}
                   
                  //  rules={[{ required: true }]}
                  >
                    <Input  readOnly={true} />
                  </Form.Item>   

                  <Form.Item
                    name="chassisNo"
                    label={this.context.translate("_CHASSIS_NUMBER_")}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>        
                  
                </Col>

                <Col span={12} className="formColumnClass">

                   <Form.Item
                    name="vehicleModel"
                    label={this.context.translate("_VEHICLE_MODEL_")}
                  //  rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>        
                  

                <Form.Item
                        name="serviceDate"
                        // label="Date Of Birth"
                        label={this.context.translate("_SERVICE_DATE_")}
                        rules={[{ type: Date }]}
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          style={{ width: "100%" }}
                          defaultValue={this.state.serviceDate}
                          onChange={(val) => {
                              val !== null &&
                                this.setState({serviceDate: val});
                          }}
                        />
                      </Form.Item>
                       <Form.Item
                        name="expiryDate"
                        // label="Date Of Birth"
                        label={this.context.translate("_EXPIRY_DATE_")}
                        rules={[{ type: Date }]}
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          style={{ width: "100%" }}
                        //defaultValue={dayjs().startOf("day")}
                        onChange={(val) => {
                              val !== null &&
                                this.setState({
                                  expiryDate: val,
                                });
                            }}
                        />
                      </Form.Item>

                        <Form.Item
                      name="status"
                      label={this.context.translate(
                        "_STATUS_"
                      )}
                      rules={[{ required: true,message: this.context.translate("_FLEET_USER_USERDETAIL_STATUSDDL_SELECT_") }]}
                    >
                      <Select
                        placeholder={this.context.translate(
                                  "_SELECT_STATUS_"
                                )}
                        onChange={async (val, option) => {
                            //await this.selectCreditType(val, option);
                        }}        
                      >
                       
                    
                        <Select.Option value="1">
                          {this.context.translate("_INSTALLED_")}
                        </Select.Option>
                         <Select.Option value="2">
                          {this.context.translate("_UNINSTALLED_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="certificateType"
                      label={this.context.translate(
                        "_CERTIFICATE_TYPE"
                      )}
                      rules={[{ required: true,message: this.context.translate("_PLEASE_SELECT_CERTIFICATE_TYPE_") }]}
                    >
                      <Select
                        placeholder={this.context.translate(
                                  "_SELECT_CERTIFICATE_TYPE_"
                                )}
                        onChange={async (val, option) => {
                            //await this.selectCreditType(val, option);
                        }}        
                      >
                       
                    
                        <Select.Option value="desertSafari">
                          {this.context.translate("_DESERT_SAFARI_")}
                        </Select.Option>
                         <Select.Option value="schoolBus">
                          {this.context.translate("_SCHOOL_BUS_")}
                        </Select.Option>
                         <Select.Option value="rentCar">
                          {this.context.translate("_RENT_CAR_")}
                        </Select.Option>
                         <Select.Option value="otherCategory">
                          {this.context.translate("_OTHER_CATEGORY_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>    
                  
                </Col>
              </Row>

              <div className="formBtnGroup">
                {/* css class */}
                <Space>
                <Button
                  //className="formCancelButton"
                  onClick={(e) => {
                    this.props.closeModal();
                    // this.formRef.current?.resetFields();
                  }}
                >
                  {/* css class */}
                  {/* Cancel */}
                  {this.context.translate("_FLEET_CLOSE_BTN_")}
                </Button>
                <Button
                  type="primary"
                  //className="formSaveButton"
                  htmlType="submit"
                  loading={this.state.loading}
                
                >
                  {/* css class */}
                  {/* Save */}
                  {this.context.translate("_SUBMIT_")}
                </Button>
                
                </Space>
              </div>
            </Form>
          </Spin>
        </div>
        
      </div>
    );
  }
}
CreditRequestAdd.contextType = StoreContext;
export default observer(withRouter(CreditRequestAdd));
